/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from 'react-query';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import categoryService from 'service/category';
import './style.scss';
import Button from 'components/base/Button';

interface GoodsCategoryFilterProps {
  setOpenCategoryModal: (show: boolean) => void;
  setSelectedCategoryData?: any;
}
const GoodsCategoryFilter = ({
  setOpenCategoryModal,
  setSelectedCategoryData
}: GoodsCategoryFilterProps) => {
  const { t, i18n } = useTranslation();
  //GET Category to options
  const { data: categoryData } = useQuery(['GET_CATEGORY'], async () => {
    const res = await categoryService
      .getList({ offset: 0, limit: 100 })
      .then((res: any) => res?.categories);

    return res;
  });

  const buildMenu = (data: any, parentId = undefined) => {
    const menu: any[] = [];
    data.forEach((item: any) => {
      if (item?.parent_pid === parentId) {
        const children = buildMenu(data, item?.pid);
        const menuItem = {
          pid: item?.pid,
          label: item?.name?.[i18n?.language] || '', // assuming you want the Russian names
          submenu: children?.length > 0 ? children : undefined,
          showSubmenu: false
        };

        menu.push(menuItem);
      }
    });

    return menu;
  };

  const [menuData, setMenuData] = useState<any[]>([]);
  const [selectedData, setSelectedData] = useState(null);

  useEffect(() => {
    if (categoryData) {
      setMenuData(buildMenu(categoryData));
    }
  }, [categoryData]);

  const toggleSubMenu = (e: any, categoryId: any) => {
    e.stopPropagation();

    const submenu = e.target.querySelector('ul');

    if (!submenu) return;

    if (submenu.style.display === 'none' || !submenu.style.display) {
      submenu.style.display = 'block';
    } else {
      submenu.style.display = 'none';
    }

    const updatedMenuData = menuData.map(item => {
      if (item.pid === categoryId && item.submenu) {
        item.showSubmenu = !item.showSubmenu;
      }
      return item;
    });

    setMenuData(updatedMenuData);
  };

  const handleCheckboxChange = (pid: any) => {
    const updateMenuDataRecursively = (menuData: any[]) => {
      return menuData.map(item => {
        if (item.pid === pid) {
          item.checked = true;
        } else {
          item.checked = false;
        }

        if (item.submenu) {
          item.submenu = updateMenuDataRecursively(item.submenu);
        }

        return item;
      });
    };

    const updatedMenuData = updateMenuDataRecursively(menuData);

    setMenuData(updatedMenuData);
    setSelectedData(pid);
  };

  const renderSubMenu = (subMenu: any) => {
    return (
      <ul className="submenu">
        {subMenu.map((subItem: any, index: any) => (
          <li key={index} onClick={e => toggleSubMenu(e, subItem.pid)}>
            {subItem.label}

            {subItem.submenu ? (
              <>
                {!subItem?.showSubmenu && (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    transform={{ size: 14 }}
                    style={{ marginLeft: '5px' }}
                  />
                )}

                {renderSubMenu(subItem.submenu)}
              </>
            ) : (
              <LastItemCheckbox
                pid={subItem.pid}
                checked={subItem.checked}
                handleCheckboxChange={handleCheckboxChange}
              />
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleSubmit = () => {
    if (!selectedData) return;

    const findSelectedItem = (items: any[]): any => {
      for (let i = 0; i < items.length; i++) {
        if (items[i].pid === selectedData) {
          return items[i];
        }
        if (items[i].submenu) {
          const foundItem = findSelectedItem(items[i].submenu);
          console.log('foundItem', foundItem);
          if (foundItem) return foundItem;
        }
      }
      return null;
    };

    const selectedCategory = findSelectedItem(menuData);

    if (selectedCategory) {
      const { pid, label } = selectedCategory;
      const selectedObject = { pid, label };
      setSelectedCategoryData(selectedObject);
      setOpenCategoryModal(false);
      // Do something with selectedObject
    } else {
      console.log('Selected category not found');
    }
  };

  return (
    <div>
      <ul className="main-cat">
        {menuData.map((item, index) => (
          <li key={index} onClick={e => toggleSubMenu(e, item.pid)}>
            {item.label}

            {item?.showSubmenu ? (
              <FontAwesomeIcon
                icon={faChevronUp}
                transform={{ size: 14 }}
                style={{ marginLeft: '5px' }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faChevronDown}
                transform={{ size: 14 }}
                style={{ marginLeft: '5px' }}
              />
            )}
            {item.submenu && renderSubMenu(item.submenu)}
          </li>
        ))}
      </ul>

      <Button
        onClick={() => handleSubmit()}
        className="w-100 mt-2"
        variant="primary"
      >
        {t('apply')}
      </Button>
    </div>
  );
};

const LastItemCheckbox = ({
  pid,
  checked,
  handleCheckboxChange
}: {
  pid: any;
  checked: boolean;
  handleCheckboxChange: (id: any) => void;
}) => {
  const handleCheckboxChangeLocal = () => {
    handleCheckboxChange(pid);
  };

  return (
    <>
      <input
        className="form-check-input"
        type="checkbox"
        checked={checked}
        onChange={handleCheckboxChangeLocal}
        style={{ marginLeft: '10px', cursor: 'pointer' }}
      />
    </>
  );
};

export default GoodsCategoryFilter;
